import { fetchWrapper } from "@/helpers";

const ruta = process.env.VUE_APP_ROOT_API;

export default class AjusteInventarioService {
  async saveAjusteInventario(datos) {
    return await fetchWrapper.post(`${ruta}/ajuste_inventario`, datos);
  }
}
